// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Button from '@mui/material/Button'
import { gql } from 'graphql-tag'
import isEqual from 'lodash/isEqual'
import omit from 'lodash/omit'
import React from 'react'
import { Mutation } from 'react-apollo'
import type { RouterHistory } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import Textarea from '../../common/textarea/Textarea'
import RestrictedView from '../auth/RestrictedView'
import CustomerTargetBar from '../customerTarget/CustomerTargetBar'
import { i18n } from '../index'
import css from './dailyInfo.css'
import DailyInfoBuffetMenu from './DailyInfoBuffetMenu'
import DailyInfoReservationsTable from './DailyInfoReservationsTable'

const UPSERT_DAILY_INFO_MUTATION = gql`
  mutation UpsertDailyInfo($stationId: ID!, $data: DailyInfoInputType!) {
    upsertDailyInfo(stationId: $stationId, data: $data) {
      id
      date
      allergyInfo {
        dishName
        lactoseFree
        glutenFree
        dairyFree
        vegan
      }
      allergyChecked
      otherInfo
    }
  }
`

type Props = {
  edit: boolean
  date: string
  stationId: string
  dailyInfo: any
  reservations: any
  history: RouterHistory
  onCancel: (...args: Array<any>) => any
}

type State = {
  formData: any
}

const defaultFormData = {
  allergyInfo: [],
  allergyChecked: false,
  otherInfo: '',
}

const getFormData = (dailyInfo?: any) => {
  return dailyInfo
    ? {
        allergyInfo: dailyInfo.allergyInfo.map((item) => ({
          ...omit(item, ['__typename']),
          lactoseFree: !!item.lactoseFree,
          glutenFree: !!item.glutenFree,
          dairyFree: !!item.dairyFree,
          vegan: !!item.vegan,
        })),
        allergyChecked: !!dailyInfo.allergyChecked,
        otherInfo: dailyInfo.otherInfo || '',
      }
    : { ...defaultFormData }
}

class DailyInfoForm extends React.Component<Props, State> {
  state: State = {
    formData: getFormData(this.props.dailyInfo),
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const { dailyInfo } = this.props

    if (dailyInfo && !isEqual(dailyInfo, prevProps.dailyInfo)) {
      this.setState({
        formData: getFormData(dailyInfo),
      })
    }
  }

  setFieldValue = (field: string, value: any) => {
    this.setState({
      formData: { ...this.state.formData, [field]: value },
    })
  }
  getFieldValue = (field: string) => {
    return this.state.formData[field]
  }
  onSubmit = (mutation: (...args: Array<any>) => any) => {
    const { stationId, date } = this.props
    const { formData } = this.state
    mutation({
      variables: {
        stationId: stationId,
        data: { ...formData, date: date },
      },
    })
  }
  onCompleted = () => {
    this.props.onCancel()
  }

  render() {
    const { edit, date, dailyInfo, reservations, stationId, onCancel } = this.props

    return (
      <Mutation
        mutation={UPSERT_DAILY_INFO_MUTATION}
        refetchQueries={() => ['DailyInfoQuery']}
        onCompleted={this.onCompleted}
      >
        {(mutation) => (
          <RestrictedView requiredPermission='edit_dailyInfo'>
            {(hasPermission) => (
              <div className={css.component}>
                <div className={css.customerTarget}>
                  <CustomerTargetBar
                    className={css.customerTargetBar}
                    title={i18n.t('dailyInfo.customerTargetTitle')}
                    showCheckButton={false}
                    date={date}
                  />
                </div>
                <div className={css.reservations}>
                  <h3>{i18n.t('dailyInfo.reservationsTitle')}</h3>
                  <DailyInfoReservationsTable
                    stationId={stationId}
                    date={date}
                    items={reservations}
                    edit={edit}
                    mealOptions={dailyInfo.mealOptions}
                  />
                </div>
                <div className={css.menu}>
                  <h3>{i18n.t('dailyInfo.buffetMenuTitle')}</h3>
                  <DailyInfoBuffetMenu
                    items={this.getFieldValue('allergyInfo')}
                    allergyChecked={!!this.getFieldValue('allergyChecked')}
                    onChange={(value) => this.setFieldValue('allergyInfo', value)}
                    onCheckedChange={(value) => this.setFieldValue('allergyChecked', value)}
                    edit={edit}
                  />
                </div>
                <div className={css.otherThings}>
                  <h3>{i18n.t('dailyInfo.otherThingsTitle')}</h3>
                  {!edit && <p>{this.getFieldValue('otherInfo')}</p>}
                  {edit && (
                    <Textarea
                      value={this.getFieldValue('otherInfo')}
                      onChange={(e) => this.setFieldValue('otherInfo', e.target.value)}
                      rows={8}
                    />
                  )}
                </div>
                <div className={css.actions}>
                  {dailyInfo && !!dailyInfo.id && (
                    <Button onClick={() => onCancel()}>{i18n.t('buttons.cancel')}</Button>
                  )}
                  {hasPermission && (
                    <Button type='input' variant='contained' color='primary' onClick={() => this.onSubmit(mutation)}>
                      {i18n.t('buttons.save')}
                    </Button>
                  )}
                </div>
              </div>
            )}
          </RestrictedView>
        )}
      </Mutation>
    )
  }
}

export default withRouter(DailyInfoForm)
